const countChecked = (dateFrom: string, dateTo: string): number => {
  const startDate: number = new Date(dateFrom).getTime();
  const finishDate: number = new Date(dateTo).getTime();
  const timeDifference: number = (finishDate - startDate);
  const secondsInADay: number = 24 * 60 * 60 * 1000;
  const days: number = Math.floor(timeDifference / secondsInADay);

  return 45465 + Math.round(1.8 * days * 24);
};

export default countChecked;
